import { createContext } from 'react';
import { createTheme } from '../createTheme/createTheme';
import { HoneycombStyleSystemProps, HoneycombTheme } from '../types';

export type Direction = 'ltr' | 'rtl';

export type ThemeContextValues = {
    theme: HoneycombTheme;
    isDefaultTheme: boolean;
    customStyleProps: {
        [key: string]: HoneycombStyleSystemProps;
    };
};

export const ThemeContext = createContext<ThemeContextValues>({
    // We provide a default theme so that components do not need to be wrapped in a HoneycombThemeProvider.
    theme: createTheme(),
    isDefaultTheme: true,
    customStyleProps: {},
});
